
import ECharts from 'echarts'
import qs from 'qs'
// eslint-disable-next-line no-unused-vars
import wx from 'weixin-js-sdk'

export default {
  name: 'Index',
  data() {
    return {
      charts: '',
    }
  },
  mounted() {
    document.title = this.$t('append_field.home')
    /*this.$ajax('/etv/getWeixinAccessToken.json').then(res => {
      if (res.data.code === 0) {
        wx.config({
          debug: false,//是否开启调试
           appid: 'wxf4ecc1546a053d74',
          // appid: 'wx7c28fd1ca82ad829',
          // appid: 'wxa12dcf325e893ef5',
          timestamp: res.data.data.timestamp,//时间搓，单位秒
          nonceStr: res.data.data.nonceStr,//随机字符串
          signature: res.data.data.signature,//签名md5
          jsApiList: ['scanQRCode'],
        })
      } else {
        Toast(res.data.msg)
      }
    })*/
    this.getDataa(localStorage.getItem('userId'))

  },
  methods: {
    getAECharts(id, data) {
      let charts = ECharts.init(document.getElementById(id))
      charts.setOption({
        color: ['#006EFF', '#2FC25B', '#999966', '#F04864', '#CC3399', '#FACC14', '#CC6600'],
        legend: {
          x: 'center',
          y: 'bottom',
          show: true,
          margin: 4,
          itemWidth: 8,
          itemHeight: 8,
        },
        series: [
          {
            name: this.$t('append_field.source_of_visit'),
            type: 'pie',
            radius: ['30%', '60%'],
            center: ['50%', '40%'],
            minAngle: 4,
            startAngle: 380,
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'outer',
                  formatter: '{d}%',
                },
                labelLine: {
                  show: true,
                  length: 10,
                },
              },
              emphasis: {
                label: {
                  show: true,
                  position: 'center',
                  textStyle: {
                    fontSize: '15',
                    fontWeight: 'normal',
                  },
                },
              },
            },
            data: data,
          },
        ],
      })

    },
    getDataa(id) {
      this.$ajax.post('/etv/selectIndexStats.json').then(res => {
        if (res.data.code === 0) {
          let data = [{
            'name': this.$t('append_field.online'),
            'value': res.data.data.onLineNum,
          }, {
            'name': this.$t('append_field.offline'),
            'value': res.data.data.offLineNum,
          }]
          this.getAECharts('a', data)
        }
      })
      this.$ajax.post('/etv/selectPersonerInfoById.json', qs.stringify({
        id,
      })).then(res => {
        if (res.data.code === 0) {
          let data = []
          res.data.data.everyTypeRam && res.data.data.everyTypeRam.map(res => {
            data.push({
              name: res.name,
              value: res.y,
            })
          })
          this.getAECharts('b', data)
        }
      })
    },
    reload() {
      this.getAECharts('a', '')
      this.getAECharts('b', '')
      this.getDataa(localStorage.getItem('userId'))
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    },

    inputDialogClose() {
      this.showPicker = false
      this.programShow = false
      this.programgroupName = ''
    },

  },
}
